// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2uQ29","header":"PatientBlock_header__2orGS","label":"PatientBlock_label__GGxDW","option":"PatientBlock_option__1ifS4"};